// extracted by mini-css-extract-plugin
export var header = "_ge-0";